import { PaymentMethod } from 'modules/purchase/constants'

import modalCreditCardActiveImage from 'assets/images/sprite/4-active-card-icons.svg'
import modalDisabledCreditCardImage from 'assets/images/sprite/4-disabled-card-icons.svg'
import applePayActiveLongImage from 'assets/images/sprite/apple-pay-active-payment.svg'
import creditCardActiveImage from 'assets/images/sprite/card-icons-active-payment.svg'
import creditCardActiveAltImage from 'assets/images/sprite/credit-card-short-icon.svg'
import googlePayActiveLongImage from 'assets/images/sprite/google-pay-active-payment.svg'
import payPalActiveLongImage from 'assets/images/sprite/paypal-active-payment.svg'
import payPalActiveLongAltImage from 'assets/images/sprite/paypal-short-icon.svg'
import upiActiveImage from 'assets/images/sprite/upi-active-payment.svg'
import upiDisabledImage from 'assets/images/sprite/upi-disabled-payment.svg'

import { Cohort } from 'root-constants'

import { TCohortTitles, TPaymentPageCohortConfig } from './types'

export const PAYMENT_METHODS_IMAGES_LONG = {
  [PaymentMethod.APPLE_PAY]: applePayActiveLongImage,
  [PaymentMethod.GOOGLE_PAY]: googlePayActiveLongImage,
  [PaymentMethod.CREDIT_CARD]: creditCardActiveImage,
  [PaymentMethod.PAYPAL]: payPalActiveLongImage,
}

export const PAYMENT_METHODS_IMAGES_LONG_V2 = {
  [PaymentMethod.APPLE_PAY]: applePayActiveLongImage,
  [PaymentMethod.GOOGLE_PAY]: googlePayActiveLongImage,
  [PaymentMethod.CREDIT_CARD]: modalCreditCardActiveImage,
  [PaymentMethod.PAYPAL]: payPalActiveLongImage,
  [PaymentMethod.UPI]: upiActiveImage,
}

export const PAYMENT_METHODS_DISABLED_IMAGES = {
  [PaymentMethod.CREDIT_CARD]: modalDisabledCreditCardImage,
  [PaymentMethod.PAYPAL]: payPalActiveLongAltImage,
  [PaymentMethod.UPI]: upiDisabledImage,
}

export const PAYMENT_METHODS_IMAGES_LONG_ALT = {
  [PaymentMethod.CREDIT_CARD]: creditCardActiveAltImage,
  [PaymentMethod.PAYPAL]: payPalActiveLongAltImage,
}

export const SUPPORTED_DEFAULT_ALTERNATIVE_PAYMENT_METHODS: PaymentMethod[] = [
  PaymentMethod.GOOGLE_PAY,
  PaymentMethod.APPLE_PAY,
  PaymentMethod.PAYPAL,
]

export const SUPPORTED_PAYPAL_FIRST_ALTERNATIVE_PAYMENT_METHODS: PaymentMethod[] =
  [PaymentMethod.PAYPAL, PaymentMethod.GOOGLE_PAY, PaymentMethod.APPLE_PAY]

export const SUPPORTED_DIGITAL_WALLET_PAYMENT_METHODS = [
  PaymentMethod.GOOGLE_PAY,
  PaymentMethod.APPLE_PAY,
]

const TITLES_V1: TCohortTitles = {
  withMethods: 'paymentLong.stayWithUsTitle',
  withoutMethods: 'paymentLong.stayWithUsTitle',
}

export const TITLES_BY_COHORT: Record<string, TPaymentPageCohortConfig> = {
  [Cohort.FLOW_1_INTRO_LONG_2251]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.FLOW_1_INTRO_LONG_2271]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.FLOW_1_INTRO_LONG_2271_C]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.FLOW_1_INTRO_LONG_4412]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.FLOW_1_INTRO_LONG_2467]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.FLOW_1_INTRO_LONG_2468]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.FLOW_1_INTRO_LONG_2469]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.FLOW_1_INTRO_LONG_3350]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.FLOW_AYAH_313]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.FLOW_AYAH_313_AM]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_QURAN_313_C]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_KNOWLEDGE_428_C]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_QURAN_313_CF]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_QURAN_313_C_AM]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_QURAN_313_CC]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_QURAN_313_CT]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_QURAN_337]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_QURAN_326]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_PA_440]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_PA_440_AM]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_PA_440_C]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_PA_440_C_AM]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_QURAN_315]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_QURAN_610]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.AP_PRINTABLE_520]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.BP_HEALING_2433]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.KP_BS_13]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.KP_BS_13_C]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.KP_BS_13_CC]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.KP_BS_13_CT]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.KP_BS_13_H]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  [Cohort.BP_BIBLE_2284]: {
    titles: TITLES_V1,
    isLarge: true,
  },
  default: {
    titles: {
      withMethods: 'paymentLong.selectPaymentTitle',
      withoutMethods: 'paymentLong.checkout',
    },
    isLarge: false,
  },
}

export const COHORTS_WITH_PAY_FAST_LABEL = [
  Cohort.AP_QURAN_315,
  Cohort.AP_QURAN_610,
]
